import script from "./customLinks.vue?vue&type=script&setup=true&lang=js"
export * from "./customLinks.vue?vue&type=script&setup=true&lang=js"

import "./customLinks.vue?vue&type=style&index=0&id=6257ce58&lang=scss&scoped=true"

import exportComponent from "/home/steffen/Projekte/clubadmin/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6257ce58"]])

export default __exports__